import { mediaViewerEngagementConfig } from '@/lib/analytics/kpis/twitter/mvConfig/mediaViewerEngagement';
import { mediaViewerEngagementOnImpressionsConfig } from '@/lib/analytics/kpis/twitter/mvConfig/mediaViewerEngagementOnImpressions';
import { mediaViewerImpressionsConfig } from '@/lib/analytics/kpis/twitter/mvConfig/mediaViewerImpressions';
import { mediaViewerLikesConfig } from '@/lib/analytics/kpis/twitter/mvConfig/mediaViewerLikes';
import { mediaViewerRepliesReceivedConfig } from '@/lib/analytics/kpis/twitter/mvConfig/mediaViewerRepliesReceived';
import { mediaViewerRetweetsSimpleConfig } from '@/lib/analytics/kpis/twitter/mvConfig/mediaViewerRetweetsSimple';
import { mediaViewerViewsConfig } from '@/lib/analytics/kpis/twitter/mvConfig/mediaViewerViews';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { POST, TW_POST_TYPES } from '@/lib/posts/postTypes';

const BASIC_CONFIG = [
    mediaViewerLikesConfig,
    mediaViewerRetweetsSimpleConfig,
    mediaViewerRepliesReceivedConfig,
    mediaViewerEngagementConfig,
    mediaViewerImpressionsConfig,
    mediaViewerEngagementOnImpressionsConfig
];

const VIDEO_CONFIG = [
    { ...mediaViewerLikesConfig, size: SIZE_FULL },
    mediaViewerRetweetsSimpleConfig,
    mediaViewerRepliesReceivedConfig,
    mediaViewerViewsConfig,
    mediaViewerEngagementConfig,
    mediaViewerImpressionsConfig,
    mediaViewerEngagementOnImpressionsConfig
];

export const MediaViewerStatsTwitter = {
    [POST]: {
        [TW_POST_TYPES.TYPE_PHOTO]: BASIC_CONFIG,
        [TW_POST_TYPES.TYPE_CAROUSEL]: BASIC_CONFIG,
        [TW_POST_TYPES.TYPE_STATUS]: BASIC_CONFIG,
        [TW_POST_TYPES.TYPE_RETWEET]: BASIC_CONFIG,
        [TW_POST_TYPES.TYPE_RETWEET_COMMENT]: BASIC_CONFIG,
        [TW_POST_TYPES.TYPE_LINK]: BASIC_CONFIG,
        [TW_POST_TYPES.TYPE_REPLY]: BASIC_CONFIG,
        [TW_POST_TYPES.TYPE_POLL]: BASIC_CONFIG,
        [TW_POST_TYPES.TYPE_VIDEO]: VIDEO_CONFIG
    }
};
